(function () {
    const form = document.getElementById("sponsor-interest-form");
    if (!form) return;

    const submitButton = document.getElementById("submit-button");
    const formView = document.getElementById("form-view");
    const confirmationView = document.getElementById("confirmation-view");
    const serviceError = document.getElementById("service-error");
    const interestGroup = document.getElementById("interest-group");
    const submitButtonDefaultText = submitButton.textContent;
    const submitButtonSubmittingText = submitButton.dataset.submittingLabel || submitButtonDefaultText;

    const TEXT_FIELDS = ["first-name", "last-name", "company"];

    function getErrorElement(fieldId) {
        return document.getElementById(`${fieldId}-error`);
    }

    function showFieldError(fieldId) {
        const field = document.getElementById(fieldId);
        const error = getErrorElement(fieldId);

        if (field) {
            field.setAttribute("aria-invalid", "true");
            field.classList.add("error");
        }

        if (error) {
            error.classList.remove("d-none");
        }
    }

    function clearFieldError(fieldId) {
        const field = document.getElementById(fieldId);
        const error = getErrorElement(fieldId);

        if (field) {
            field.removeAttribute("aria-invalid");
            field.classList.remove("error");
        }

        if (error) {
            error.classList.add("d-none");
        }
    }

    function setInterestError(hasError) {
        interestGroup.querySelectorAll(".checkbox-item").forEach((item) => {
            item.classList.toggle("error", hasError);
        });
        getErrorElement("interest").classList.toggle("d-none", !hasError);
    }

    function clearAllErrors() {
        [...TEXT_FIELDS, "email"].forEach(clearFieldError);

        setInterestError(false);
        serviceError.classList.add("d-none");
    }

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function validateForm() {
        clearAllErrors();

        let isValid = true;
        let firstInvalidControl = null;

        const email = document.getElementById("email");
        const selectedInterests = document.querySelectorAll('input[name="interest[]"]:checked');

        const flagInvalid = (control, action) => {
            isValid = false;
            action();
            if (!firstInvalidControl) {
                firstInvalidControl = control;
            }
        };

        TEXT_FIELDS.forEach((fieldId) => {
            const field = document.getElementById(fieldId);

            if (!field.value.trim()) {
                flagInvalid(field, () => showFieldError(fieldId));
            }
        });

        if (!email.value.trim() || !isValidEmail(email.value.trim())) {
            flagInvalid(email, () => showFieldError("email"));
        }

        if (selectedInterests.length === 0) {
            // The group is a plain div and cannot take focus; its first checkbox can,
            // which is what scrolls the marked group into view.
            flagInvalid(interestGroup.querySelector('input[type="checkbox"]'), () => setInterestError(true));
        }

        if (!isValid) {
            firstInvalidControl?.focus?.();
        }

        return isValid;
    }

    function showConfirmation() {
        formView.hidden = true;
        confirmationView.classList.remove("d-none");
        confirmationView.focus?.();
        document.getElementById("form-card").scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
            block: "center"
        });
    }

    function showServiceError() {
        serviceError.classList.remove("d-none");
        serviceError.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    async function handleSubmit() {
        submitButton.disabled = true;
        submitButton.textContent = submitButtonSubmittingText;
        serviceError.classList.add("d-none");

        try {
            const response = await fetch(form.getAttribute("action"), {
                method: "POST",
                headers: { "Accept": "application/json" },
                body: new FormData(form)
            });

            if (!response.ok) {
                throw new Error("Submission failed");
            }

            showConfirmation();
        } catch (error) {
            console.error("Sponsorship interest submission failed:", error);
            showServiceError();
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = submitButtonDefaultText;
        }
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return;
        }

        await handleSubmit();
    });

    TEXT_FIELDS.forEach((fieldId) => {
        document.getElementById(fieldId).addEventListener("input", (event) => {
            if (event.target.value.trim()) clearFieldError(fieldId);
        });
    });

    document.getElementById("email").addEventListener("input", (event) => {
        if (isValidEmail(event.target.value.trim())) clearFieldError("email");
    });

    document.querySelectorAll('input[name="interest[]"]').forEach((input) => {
        input.addEventListener("change", () => {
            if (document.querySelector('input[name="interest[]"]:checked')) {
                setInterestError(false);
            }
        });
    });
})();
